
import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"

import $ from "jquery"
import Modal from "app/modal/show-modal"
import Box from "concepts/buildings/brochure/request/box/index"


import I18n from "plugins/i18n-js"
import * as Routes from "plugins/js-routes"


const CELL_CLASS_NAME = "cell--buildings--brochure--request--modal"

const show = (building_id: number | string) => {
  q_ajax_3(
    {
      url:      Routes.new_brochure_request_building_path(I18n.locale, building_id),
      method:   "GET",
      dataType: "html",
    },
    {
      error_tracking_options: {
        endpoint_identifier:
          "concepts/buildings/brochure/request/modal#show",
      },
    }
  )
  .then(({data}) => {
    if ($(CELL_CLASS_NAME).length !== 0) {
      return
    }

    Modal.showModalWithContent(data, {customContent: true})
    Box.init()
  })
}

export default {show}
